module.exports = __webpack_public_path__ + "d579d88a24d3e407b7ddc8f0d422e61f.pdf";